import { Link } from 'react-router-dom';
import { Calendar, Users, Clock } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const getLevelClass = (level) => {
  switch (level?.toLowerCase()) {
    case 'anfänger':
      return 'level-anfanger';
    case 'mittelstufe':
      return 'level-mittelstufe';
    case 'fortgeschritten':
      return 'level-fortgeschritten';
    default:
      return 'level-anfanger';
  }
};

export const CourseCard = ({ course }) => {
  const spotsLeft = course.capacity - course.enrolled;
  const isFull = spotsLeft <= 0;

  return (
    <Link to={`/courses/${course.id}`} className="block" data-testid={`course-card-${course.id}`}>
      <article className="course-card card-hover h-full flex flex-col">
        {/* Header */}
        <div className="p-6 pb-4 border-b border-border/50">
          <div className="flex items-start justify-between gap-4 mb-3">
            <Badge className={`level-badge ${getLevelClass(course.level)}`}>
              {course.level}
            </Badge>
            <span className="price-tag text-lg">€{course.price.toFixed(2)}</span>
          </div>
          <h3 className="font-heading text-xl font-semibold text-foreground mb-2">
            {course.name}
          </h3>
        </div>

        {/* Body */}
        <div className="p-6 flex-1 flex flex-col">
          <p className="text-muted-foreground text-sm leading-relaxed mb-4 line-clamp-3 flex-1">
            {course.description}
          </p>

          {/* Meta */}
          <div className="space-y-2 text-sm">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Calendar className="w-4 h-4 text-primary" />
              <span>Start: {new Date(course.start_date).toLocaleDateString('de-DE')}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Clock className="w-4 h-4 text-primary" />
              <span>{course.schedule}</span>
            </div>
            <div className="flex items-center gap-2">
              <Users className="w-4 h-4 text-primary" />
              {isFull ? (
                <span className="text-destructive font-medium">Ausgebucht</span>
              ) : (
                <span className="text-muted-foreground">
                  {spotsLeft} von {course.capacity} Plätzen frei
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 pt-0">
          <div className="text-xs uppercase tracking-widest text-primary font-medium">
            Mehr erfahren →
          </div>
        </div>
      </article>
    </Link>
  );
};
